$(document).ready(function(){
    // Custom Add To Card
    $(document).on('click', '.zx-add-to-cart', function(e){
        e.preventDefault();
        const Zx_Variant_ID = parseInt($(this).attr('data-variant'), 10);
        const PreLoader = $(document).find('.page-preloader-wrapper.js-page-preloader');

        PreLoader.css('display', 'flex');
        addToCartAndOpenDrawer(Zx_Variant_ID, 1);
        PreLoader.css('display', 'none');
    });

    // Product Nav Product Switch
    $(document).on('click', '.zx-nav-product', function(e){
        e.preventDefault();

        let product_html   = $(this).closest('.zx-product-card');
        let product_title  = $(this).attr('data-title');
        let product_price  = $(this).find('span').html();
        let product_link   = $(this).attr('href');
        let product_image  = $(this).attr('data-image');
        let product_vrnt   = $(this).attr('data-variant');
        let product_handle = $(this).attr('data-handle');

        product_html.find('.product-card__title').text(product_title);
        product_html.find('.product-card__title').attr('href', product_link);
        product_html.find('.product-card__price').html(product_price);
        product_html.find('.product-card__image-wrapper-link').attr('href', product_link);
        product_html.find('.product-card__image-wrapper-link').attr('aria-label', product_title);
        product_html.find('.zx-pc-link').attr('href', product_link);
        product_html.find('.product-card__image-wrapper').attr('data-variant', product_vrnt);
        product_html.find('.product-card__image-picture img').attr('srcset', '');
        product_html.find('.product-card__image-picture img').attr('src', product_image);
        product_html.find('.product-card__image-picture source').attr('srcset', product_image);
        product_html.find('.zx-add-to-cart').attr('data-product-card-handle', product_handle);
        product_html.find('.zx-add-to-cart').attr('data-variant', product_vrnt);
        product_html.find('.zx-quick-view').attr('data-product-card-handle', product_handle);

        product_html.find('.zx-nav-product').removeClass('active');
        $(this).addClass('active');
    });
  
    // Product Nav Slider - Clean Timeout Version
    function initializeProductNavSlider(attempts = 0, maxAttempts = 50) {
        var elms = document.getElementsByClassName('zx-product-nav');
        
        if (elms.length > 0 && typeof Splide !== 'undefined') {
            var splideOptions = {
                type: 'slide',
                perPage: 3,
                rewind: false,
                arrows: true,
                pagination: false,
                drag: true,
                autoplay: false,
                gap: 15,
                focus: 0,
                trimSpace: false,
                breakpoints: {
                    1024: { perPage: 3 },
                    768: { perPage: 2 },
                    480: { perPage: 3, arrows: false }
                }
            };
            
            for (var i = 0; i < elms.length; i++) {
                new Splide(elms[i], splideOptions).mount();
            }
            
            console.log('Splide initialized successfully!');
            return true;
        }
        
        if (attempts < maxAttempts) {
            setTimeout(function() {
                initializeProductNavSlider(attempts + 1, maxAttempts);
            }, 100);
        } else {
            console.error('Splide initialization failed after ' + maxAttempts + ' attempts');
        }
    }

    // Call the function
    initializeProductNavSlider();

    $(document).on('click', '.header__logo .header__heading-link', function (e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 600);
    });
  
});

/**
 * Adds a variant to the cart and opens the updated cart drawer.
 *
 * @param {Number} variantId - The product variant ID
 * @param {Number} quantity - The quantity to add
 */
async function addToCartAndOpenDrawer(variantId, quantity = 1) {
  try {
    // Add the item to the cart using theme's native CartApi
    await window.themeCore.CartApi.makeRequest(
      window.themeCore.CartApi.actions.ADD_TO_CART,
      {
        id: variantId,
        quantity: Number(quantity)
      }
    );

    // Fetch updated cart to get correct count
    const cartData = await window.themeCore.CartApi.makeRequest(
      window.themeCore.CartApi.actions.GET_CART
    );

    // Manually update cart count
    updateHeaderCartCount(cartData.item_count);

    // Refresh and open the cart drawer using theme's EventBus
    window.themeCore.EventBus.emit("cart:drawer:refresh-and-open");

    // OPTIONAL: Show notification (if your theme requires it separately)
    // window.themeCore.EventBus.emit("cart-notification:open");

  } catch (error) {
    const CartNotificationError = window.themeCore.CartNotificationError;
    if (CartNotificationError && error?.description) {
      CartNotificationError.addNotification(error.description);
      CartNotificationError.open();
    } else {
      console.error("Add to cart error:", error);
    }
  }
}

function updateHeaderCartCount(newCount) 
{
  const countWrapper = document.querySelector('.js-header-cart-item-count-wrapper');
  const countSpan = document.querySelector('.js-header-cart-item-count');

  if (countWrapper && countSpan) {
    countWrapper.setAttribute('data-cart-count', newCount);
    countSpan.textContent = newCount;
  }
}
